import client from "../../graphql/client";
import { loader } from "graphql.macro";

const createOrganisationLabelMutation = loader("../../graphql/mutations/adminOrganisationLabelCreate.graphql");

export default function createOrganisationLabelAction(label) {
    return () => {
        return client.mutate({
            mutation: createOrganisationLabelMutation,
            variables: { name: label }
        });
    };
}
